import { ProducerTypes, ReportTypes } from '@mode/shared/contract-common';

interface SimpleReportParams {
  report: {
    name: string;
    description: string;
    layout: string;
    datasets: {
      producer_type: ProducerTypes;
      document_id: string;
      worksheet_id?: string | number;
      create_data_run: boolean;
    }[];
    type: ReportTypes.ReportType;
  };
}

export function createParams(
  name: string,
  description: string,
  layout: string,
  spreadsheetId: string,
  worksheetId?: string | number
): SimpleReportParams {
  return {
    report: {
      name,
      description,
      layout,
      datasets: [
        {
          producer_type: ProducerTypes.GoogleSheet,
          document_id: spreadsheetId,
          worksheet_id: worksheetId,
          create_data_run: true,
        },
      ],
      type: ReportTypes.ReportType.DatasetReport,
    },
  };
}
